import { Component } from 'react';
import ListTransaction from '../components/ListTransaction';

import { executeGet, executePost, createNewHeaders, updateHeaders } from '../functions/Kubuku';
import { DAFTAR_TRANSAKSI } from '../api';

import CardDetailTransaksi from '../components/CardDetailTransaksi';
import ModalLoading from "../components/ModalLoading";
import ModalPopup from "../components/ModalPopup";

class Transaction extends Component {

    constructor(props) {
        super(props)
        this.state = {
            currentPage: 1,
            flagData: false,
            data: '',
            dataAll: '',
            showDetail: false,
            detailData: '',
            shareKode: false,
            order_id: '',
            flagBelumBayar: false,
            flagBatalBayar: false,
            flagSukseBayar: false,
            flagLanjut: false,
            status: ''
        }
    }

    componentDidMount() {
        this.getTransaksi();
    }

    getTransaksi = async () => {

        try {
            const flagOpen = localStorage.getItem('flagOpen');
            console.log("flagOpen = " + flagOpen);
            if(flagOpen != "1") {
            createNewHeaders('', ''); 
            } else {
            updateHeaders('', ''); 
            }
            let formData = new FormData();
            formData.append("page", "1");
            formData.append("row", "100");

            const json = await executePost(DAFTAR_TRANSAKSI, formData);
            //console.log("transaksi = " + JSON.stringify(json));
            if (json.code == 200) {
                
                this.setState({ flagData: true, data: json.data, dataAll: json.data });
                this.belumBayar();
            } else if (json.code == 500 || json.code == 505) {
                //window.location.href = window.location.origin + "/login";
            }
        } catch (error) {
            //console.log(error);
            this.setState({ isError: true, errorMessage: "Network Error!" });
        }
    }

    detailTransaksi = async (item) => {
        this.setState({ order_id: item.order_id });
        this.setState({ status: item.status })
        this.setState({ flagData: false, showDetail: true, detailData: item.data });
        /*
        if (item.status == "pending") {
            console.log("show cara bayar = " + item.paymentUrl);
            //window.location.href = item.paymentUrl;
            this.setState({ flagData: false, showDetail: true, detailData: item.data });
        } else if (item.status == "sukses") {
            this.setState({ flagData: false, showDetail: true, detailData: item.data });
        }
        */
    }

    belumBayar = () => {
        console.log("belumBayar");
        let dataRes = this.state.dataAll.filter(function (data) {
            return data.status == "pending";
        });
        this.setState({ data: dataRes, flagBelumBayar: true, flagBatalBayar: false, flagSukseBayar: false });
        //this.setState({ data: dataRes, flagBelumBayar: false, flagBatalBayar: true, flagSukseBayar: false });
        // console.log("belumBayar = " + JSON.stringify(dataRes))
    }

    batalBayar = () => {
        console.log("batalBayarr");
        let dataRes = this.state.dataAll.filter(function (data) {
            return data.status == "expired";
        });
        this.setState({ data: dataRes, flagBelumBayar: false, flagBatalBayar: true, flagSukseBayar: false });
        // console.log("belumBayar = " + JSON.stringify(dataRes))
    }

    suksesBayar = () => {
        console.log("suksesBayar");
        let dataRes = this.state.dataAll.filter(function (data) {
            return data.status == "sukses";
        });
        this.setState({ data: dataRes, flagBelumBayar: false, flagBatalBayar: false, flagSukseBayar: true });
        // console.log("belumBayar = " + JSON.stringify(dataRes))
    }

    render() {
        return (
            <div>
                { this.state.flagData &&
                    <div>
                        <div className="hidden md:block dark:bg-white border rounded-2xl p-[30px]">
                            <div className="text-4xl font-semibold dark:text-black pb-6">List Transaksi</div>
                            <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400">
                                <li className="mr-2">
                                    <a onClick={() => this.belumBayar()} className={this.state.flagBelumBayar ? "cursor-pointer inline-block p-4 text-greenWalang bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500" : "cursor-pointer inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"}>Belum Bayar</a>
                                </li>
                                <li className="mr-2">
                                    <a onClick={() => this.batalBayar()} className={this.state.flagBatalBayar ? "cursor-pointer inline-block p-4 text-greenWalang bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500" : "cursor-pointer inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"}>Waktu Bayar Habis</a>
                                </li>
                                <li className="mr-2">
                                    <a onClick={() => this.suksesBayar()} className={this.state.flagSukseBayar ? "cursor-pointer inline-block p-4 text-greenWalang bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500" : "cursor-pointer inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"}>Berhasil</a>
                                </li>
                            </ul>
                            {this.state.data.map((row) => {
                                return (
                                    <ListTransaction
                                        key={row.order_id}
                                        data={row}
                                        detailTransaksi={() => { this.detailTransaksi(row) }}
                                    />
                                );
                            })}
                        </div>
                        {/** Mobile */}
                        <div className="block md:hidden dark:bg-white mb-20">
                            <div className="text-xl font-semibold dark:text-black pb-3">List Transaksi</div>
                            <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400">
                                <li className="mr-2">
                                    <a onClick={() => this.belumBayar()} className={this.state.flagBelumBayar ? "cursor-pointer inline-block p-3 text-greenWalang bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500" : "cursor-pointer inline-block p-3 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"}>Belum Bayar</a>
                                </li>
                                <li className="mr-2">
                                    <a onClick={() => this.batalBayar()} className={this.state.flagBatalBayar ? "cursor-pointer inline-block p-3 text-greenWalang bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500" : "cursor-pointer inline-block p-3 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"}>Dibatalkan</a>
                                </li>
                                <li className="mr-2">
                                    <a onClick={() => this.suksesBayar()} className={this.state.flagSukseBayar ? "cursor-pointer inline-block p-3 text-greenWalang bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500" : "cursor-pointer inline-block p-3 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"}>Berhasil</a>
                                </li>
                            </ul>
                            {this.state.data.map((row) => {
                                return (
                                    <ListTransaction
                                        key={row.order_id}
                                        data={row}
                                        detailTransaksi={() => { this.detailTransaksi(row) }}
                                    />
                                );
                            })}
                        </div>

                    </div>
                }

                {
                    this.state.showDetail &&
                    <div className="border border-grayWalang p-6 rounded-2xl">
                        <div className="flex">
                            <div className="w-[70%] text-lg lg:text-4xl font-semibold dark:text-black">Detail Transaksi</div>
                            <div className="w-[30%] cursor-pointer flex justify-end items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" onClick={() => this.setState({ showDetail: false, flagData: true })}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </div>
                        </div>

                        {
                            this.state.detailData.map((row) => {
                                return (

                                    <CardDetailTransaksi
                                        key={row.kode_konten}
                                        data={row}
                                        value={row}
                                        status={this.state.status}
                                        order_id={this.state.order_id}
                                    />
                                    

                                );
                            })
                        }
                        <div className="w-full ">
                            <div className="px-1">
                                <div className="ml-6 m-t pt-4">
                                    Konten yang sudah anda beli dapat anda baca dengan Bacabuku, silahkan download di link di bawah ini
                                </div>
                                <div className="ml-6 m-t pt-4">
                                <a href="https://play.google.com/store/apps/details?id=app.bookubuku.id" className="text-[#999999] flex space-x-2">
                                <svg width="20" height="24" viewBox="0 0 20 24" fill="green" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.1154 4.66668C9.1154 5.134 8.73657 5.51283 8.26925 5.51283C7.80193 5.51283 7.4231 5.134 7.4231 4.66668C7.4231 4.19936 7.80193 3.82053 8.26925 3.82053C8.73657 3.82053 9.1154 4.19936 9.1154 4.66668Z" fill="#999999" />
                                    <path d="M11.6539 5.51283C12.1212 5.51283 12.5 5.134 12.5 4.66668C12.5 4.19936 12.1212 3.82053 11.6539 3.82053C11.1866 3.82053 10.8077 4.19936 10.8077 4.66668C10.8077 5.134 11.1866 5.51283 11.6539 5.51283Z" fill="#999999" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M4.35431 0.46967C4.64721 0.176777 5.12208 0.176777 5.41497 0.46967L6.64273 1.69742C7.5836 1.13641 8.68333 0.814117 9.85833 0.814117H10.0647C11.2397 0.814117 12.3395 1.13642 13.2803 1.69744L14.5081 0.46967C14.801 0.176777 15.2759 0.176777 15.5688 0.46967C15.8617 0.762563 15.8617 1.23744 15.5688 1.53033L14.477 2.62213C15.5154 3.645 16.1999 5.02619 16.33 6.56528C16.5446 6.49383 16.7742 6.45514 17.0128 6.45514C18.2059 6.45514 19.1731 7.42232 19.1731 8.61539V13.6923C19.1731 14.8854 18.2059 15.8526 17.0128 15.8526C16.7825 15.8526 16.5607 15.8165 16.3525 15.7498V17.6154C16.3525 18.5277 15.9083 19.3362 15.2243 19.8365V21.3077C15.2243 22.6565 14.1309 23.75 12.782 23.75C11.4332 23.75 10.3397 22.6565 10.3397 21.3077V20.3654H9.58335V21.3077C9.58335 22.6565 8.48989 23.75 7.14104 23.75C5.79219 23.75 4.69873 22.6565 4.69873 21.3077V19.8365C4.01475 19.3363 3.5705 18.5277 3.5705 17.6154V15.7498C3.36238 15.8165 3.14053 15.8526 2.91026 15.8526C1.71718 15.8526 0.75 14.8854 0.75 13.6923V8.6154C0.75 7.42232 1.71718 6.45514 2.91026 6.45514C3.14888 6.45514 3.37846 6.49383 3.59308 6.56528C3.72317 5.02617 4.40765 3.64497 5.44609 2.62211L4.35431 1.53033C4.06142 1.23744 4.06142 0.762563 4.35431 0.46967ZM5.3191 7.95514C5.18167 7.95589 5.0705 8.06753 5.0705 8.20514V8.60669L5.07051 8.61539V13.6923L5.0705 13.701V17.6154C5.0705 18.3043 5.62776 18.863 6.31608 18.8654H13.607C14.2953 18.863 14.8525 18.3043 14.8525 17.6154V13.6981L14.8525 13.6923V8.6154L14.8525 8.60959V8.20514C14.8525 8.06753 14.7414 7.95589 14.6039 7.95514H5.3191ZM14.6062 6.45514H14.8092C14.4934 4.1168 12.4896 2.31412 10.0647 2.31412H9.85833C7.43344 2.31412 5.4296 4.1168 5.11381 6.45514H5.3168L5.3205 6.45514H14.6025L14.6062 6.45514ZM11.8397 21.3077V20.3654L13.6025 20.3654L13.6091 20.3654H13.7243V21.3077C13.7243 21.8281 13.3025 22.25 12.782 22.25C12.2616 22.25 11.8397 21.8281 11.8397 21.3077ZM6.31395 20.3654L6.3205 20.3654L8.08335 20.3654V21.3077C8.08335 21.8281 7.66146 22.25 7.14104 22.25C6.62062 22.25 6.19873 21.8281 6.19873 21.3077V20.3654H6.31395ZM17.0128 14.3526C16.6492 14.3526 16.3543 14.0587 16.3525 13.6955V8.61219C16.3543 8.24901 16.6492 7.95514 17.0128 7.95514C17.3774 7.95514 17.6731 8.25075 17.6731 8.61539V13.6923C17.6731 14.057 17.3774 14.3526 17.0128 14.3526ZM3.5705 8.61058C3.56791 8.24815 3.2733 7.95514 2.91026 7.95514C2.54561 7.95514 2.25 8.25075 2.25 8.6154V13.6923C2.25 14.057 2.54561 14.3526 2.91026 14.3526C3.2733 14.3526 3.56791 14.0596 3.5705 13.6971V8.61058Z" fill="#999999" />
                                </svg>
                                    <div>
                                    Android
                                    </div>
                                </a>
                                </div>
                                <div className="ml-6 m-t pt-4">
                                <a href="https://bacabuku.com/storage/bacabuku-win-x64.exe" className="text-[#999999] flex space-x-2">
                                <img width="20" src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Windows_logo_-_2012.svg/88px-Windows_logo_-_2012.svg.png"/>
                                    <div>
                                    Windows
                                    </div>
                                </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                }
            </div>
        );

    }
}

export default Transaction;
